import React, { ElementType, ForwardRefExoticComponent } from "react";
import sanitizeHtml from "sanitize-html";

export interface PurifiedComponentProps<T extends object> {
  component: ElementType | ForwardRefExoticComponent<T>;
  content: string;
}

export const PurifiedComponent = <T extends object>(props: PurifiedComponentProps<T>) => {
  const { component: Component, content } = props;

  return <Component dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }} />;
};
